import { render, staticRenderFns } from "./areaSelectName.vue?vue&type=template&id=45c9e78c"
import script from "./areaSelectName.vue?vue&type=script&lang=js"
export * from "./areaSelectName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports